const fsaDataFields = [
    { label: 'Business Name', key: 'BusinessName' },
    { label: 'Business Type', key: 'BusinessType' },
    { label: 'Address Line 1', key: 'AddressLine1' },
    { label: 'Address Line 2', key: 'AddressLine2' },
    { label: 'Address Line 3', key: 'AddressLine3' },
    { label: 'Address Line 4', key: 'AddressLine4' },
    { label: 'Postcode', key: 'POSTCODE' },
    { label: 'Previous Name', key: 'PREVIOUS_BUSINESS_NAME' },
    { label: 'Address', key: 'SingleLineAddress' },
]

export default function FSADataTable({ data, translations }) {
    return (
        <table className="table borders squish smaller-text left" style={{ width: '100%' }}>
            <thead>
                <tr>
                    <th colSpan={2}>{translations['fsa_data'] || 'FSA Data'}</th>
                </tr>
            </thead>
            <tbody>
                {fsaDataFields.map(({ label, key }) => (
                    <tr key={label}>
                        <td style={{ width: '20em' }}>{translations[label.toLowerCase().replace(/ /g, '_')] || label}</td>
                        <td>{key ? data?.[key] : ''}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}
